import { useTranslation } from "react-i18next";
import { GoChevronDown } from "react-icons/go";
import ChangeLang from "../changeLanguage";
import NotificationIcon from "../../icons/notificationIcon";
import { RxHamburgerMenu } from "react-icons/rx";
import DefultUserImage from "./defult-user-image.jpg";

const Header = ({ setOpen, open }) => {
  const { t } = useTranslation();

  return (
    <header className="py-4 text-white mainLinear h-[71px] border-b border-[#DBE0E7]">
      <div className="flex items-center justify-between h-full px-4">
        <div className="flex items-center gap-4">
          <RxHamburgerMenu
            size={24}
            className="cursor-pointer md:hidden"
            onClick={() => setOpen(!open)}
          />

          <p className="text-lg font-semibold">
            <span className=" text-primary">{t("hello,")}</span>
            <span>الريس</span>
          </p>
        </div>
        <section className="flex items-center gap-4">
          <NotificationIcon />
          <ChangeLang />
          <div className="flex items-center gap-2 cursor-pointer">
            <img
              src={DefultUserImage}
              alt="هشام المدير"
              className="object-cover rounded-full size-8"
            />
            <span className="text-sm">هشام المدير</span>
            <GoChevronDown size={16} />
          </div>
        </section>
      </div>
    </header>
  );
};

export default Header;
